<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;">
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline"
          style="margin: 0px 0px;background:rgba(255, 255, 255, 1);padding: 10px;height: 92px;">

          <el-form-item label="综合查询">
            <el-input placeholder="账号/学号/身份证号/姓名" v-model="ruleForm.Name"></el-input>
          </el-form-item>

          <el-form-item label="部门">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID"
              filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable></el-cascader>
          </el-form-item>

          <el-form-item label="年级">
            <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>

          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
        </el-form>
      </el-header>

      <div style="height:100%;background-color: #fff;margin-top: 20px;">
            <el-table :data="tableData" stripe style="width: 100%;">
              <el-table-column label="序号" width="60px" align="left">
                <template slot-scope="scope" center>
                  {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
                </template>
              </el-table-column>

              <el-table-column label="学生学号">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.userId }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.realName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="培养单位">
                <template slot-scope="scope">
                  <span>{{ scope.row.deptName }}</span>
                </template>
              </el-table-column>

              <el-table-column label="上报人">
                <template slot-scope="scope">
                  <span>{{ scope.row.reportId }}</span>
                </template>
              </el-table-column>

              <el-table-column label="上报时间">
                <template slot-scope="scope">
                    <span>{{ scope.row.reportTime }}</span>
                </template>
              </el-table-column>

              <el-table-column label="上报状态">
                <template slot-scope="scope">
                  <span>{{ scope.row.reportStatus }}</span>
                </template>
              </el-table-column>

              <el-table-column class="xsii" prop="address" label="操作">
                <template slot-scope="scope">
                  
                  <span style="cursor:pointer;color: #409EFF;" class="looks" @click="looks(scope.row.KeyNo, scope.row.type)">查看详情</span>

                  <span  v-if="scope.row.reportStatus == '未提交'" style="cursor:pointer;color: #409EFF;" class="looks" @click="lookss(scope.row.KeyNo, scope.row.type)">上报</span>
                </template>

              </el-table-column>
            </el-table>

          <el-pagination style="margin-top: 20px; text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndexs" :page-size="10" layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>
      </div>

    </el-container>
  </div>
</template>
<script>
import { number } from 'echarts/lib/export';
export default {
  data() {
    return {
      gradedata:[],
      RoleID: '',
      jiaose:'辅导员',
      DeptID: '',
      optionsnew: [],
      Count: 0,
      pageIndexs: 1,
      ruleForm: {
        Name: "",//综合查询
        DeptID: "",//培训单位
        EntryDate: "",//年级
        Degree: "",//学位
        Type: "",//上报类型
        ReportStatus: "",//上报状态
        pageIndex: 1,
        pageSize: '10'
      },
      form: {DeptName: "", RealName: "", Status: "", UserID: "", entity: "管理员", pageIndex: 1, pageSize: "10"},
      tableData: [],
    }
  },
  methods: {
    looks(KeyNo,type) {
      this.$router.push({
        path: '/Crisis/Crisis_lookreport',
        query: { KeyNo: KeyNo, type: type},
      })
    },
    lookss(KeyNo) {
      this.$router.push({
        path: '/Crisis/Daily_reports',
        query: { KeyNo: KeyNo ,type:1},
      })
    },


    
    Selected_to_shut_dow(dt) {
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...'}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length - 1],content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    gourl(val) {
      let routeData = this.$router.resolve({
        path:'/visitors/ReportShow',
        query: { PaperResultID:a},
      })
      window.open(routeData.href,'_blank');
    },
    ceshigorl() {
      this.$router.push("/Crisis/Crisis_intervention?id=111");
    },
    load(form) {//列表
      this.$Http_Post('DistressPrediction/GetUrgent',{pageSize:'10',pageIndex:this.ruleForm.pageIndex,Name:this.ruleForm.Name,DeptID:this.DeptID,EntryDate:this.ruleForm.EntryDate,Degree:this.ruleForm.Degree,Type:this.ruleForm.Type,Status:this.ruleForm.ReportStatus,RoleID: this.RoleID }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Count = res.Counts;
        }
      });
    },
    handleCurrentChange(val) {//分页点击
      this.ruleForm.pageIndex = val;
      this.load(this.form);
    },
    Go_Review_key(val) {
      sessionStorage.setItem('Crisis_upreport_type',val.row.UrgentStatus);
      this.$router.push({
        path: '../Crisis/Review_key',
        query: {id:val.row.userid,SourceNo:val.row.SourceNo,TableCngResultID:val.row.TableCngResultID},
      })
    },
    resetForm() {
      this.ruleForm.Name = '';
      this.ruleForm.DeptID = this.DeptID;
      this.ruleForm.EntryDate = '';
      this.ruleForm.Degree = '';
      this.ruleForm.ReportType = '';
      this.ruleForm.ReportState = '';
      this.ruleForm.pageIndex = 1;
      this.load();
    },
    onSelect() {
      this.load();
    },
    jump(val) {
      this.$router.push({ path: "/Crisis/report", query: {id: val}});
    },
    jum2p(val) {
      this.$router.push({ path: "/Crisis/Hotline_Crisis_Synchronization", query:{id:val}});
    }
  },
  mounted() {
    this.$Http_Post('User/GetDictionaryList', { DicTypCode: 1 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data
      }
    })
    this.RoleID = sessionStorage.getItem('RoleID');
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID:'',content:''}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
        this.ruleForm.DeptID = res.Data[0].DeptID;
        this.load(this.form);
      }
    });
  }
}

</script>

<style>
.Crisis_upreport button {
  margin-bottom: 20px;
}

.Crisis_upreport .cell span {
  margin-left: 10px;
  text-align: center;
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>